import {Axios} from '@asocial/fe-utils'
import {FacebookPixelType, TrackingEventType} from 'entities/tracking/types'

export const SendTrackedEvents = (events: TrackingEventType[]) => Axios.post('track', {events})

export const TrackPixelEvent = (type: FacebookPixelType, pixelInitializationTime: number) =>
  Axios.post(`pixels/facebook/${type}`, {pixelInitializationTime})
